export default {
  ACTIVE: 'active',
  DISABLED: 'disabled',
  DONE: 'done',
  AVAILABLE: 'available',
};
